import React, { Component } from "react";
import { Divider, Row, Layout, Button } from "antd";
import { Link } from "react-router-dom";
import ReactGA from "react-ga4";
import throttle from "lodash.throttle";
import PropTypes from "prop-types";
import BestCatsTable from "../../table/BestCatsTable";
import TierListTable from "../../table/TierListTable";
import {
  FacebookShareButton,
  RedditShareButton,
  TwitterShareButton,
  VKShareButton,
  FacebookIcon,
  RedditIcon,
  TwitterIcon,
  VKIcon,
} from "react-share";
import VenatusAd from "../../ads/VenatusAd";
import VenatusAdWithPlaceholder from "../../ads/VenatusAdWithPlaceholder";
import {
  VENATUS_DESKTOP_LEADERBOARD,
  VENATUS_MOBILE_LEADERBOARD,
  VENATUS_RICH_MEDIA_WITH_STICKY_VERTICAL,
  VENATUS_RICH_MEDIA,
} from "../../utilities/constants";

const shareURL = "https://mygamatoto.com/ultra-souls-tier-list";
const { Content } = Layout;

export const initGA = () => {
  ReactGA.initialize(
    "G-MX6GYDK28N"
    // , {
    //   gaAddress: "https://onestoppress.com/analytics.js"
    // }
  );
};

export const logPageView = () => {
  ReactGA.set({ page: window.location.pathname + window.location.search });
};

class UltraSouls extends Component {
  constructor(props) {
    super(props);
    this.state = {
      viewportWidth: 0,
      compareCatsLevels: 30,
    };
  }
  componentDidMount() {
    this.saveViewportDimensions();
    window.addEventListener("resize", this.saveViewportDimensions);

    // initGA();
    // logPageView();

    document.title = "Ultra Souls Tier List | Battle Cats Wiki for Cat Stats";
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.saveViewportDimensions);
  }

  saveViewportDimensions = throttle(() => {
    let adjustViewport;
    if (window.innerWidth < 636) {
      adjustViewport = 22;
    } else if (window.innerWidth < 948) {
      adjustViewport = 34;
    } else {
      adjustViewport = 46;
    }

    this.setState({
      viewportWidth: window.innerWidth - adjustViewport,
    });
  }, this.props.applyViewportChange);

  showModal = () => {
    this.setState({ isModalVisible: true });
  };

  handleCancel = () => {
    this.setState({ isModalVisible: false });
  };

  render() {
    const bestCats = [
      {
        key: "138-1",
        name: "Kasa Jizo",
        number: "138-1",
        form: "Normal",
        rarity: "Uber Super Rare",
        level: 1,
        health: 2250,
        damage: 1000,
        range: 320,
        kb: 3,
        speed: 14,
        dps: 305,
        target: "Area",
        tba: "3.27",
        anim: "0.63",
        spawn: "4.20",
        cost: 750,
        ability:
          "u1Against black, angelu2: b1Massive Damageb2 (inflicts 3.0x damage)",
        iscrazed: null,
        level2: this.state.compareCatsLevels,
      },
      {
        key: "452-1",
        name: "Ushiwakamaru",
        number: "452-1",
        form: "Normal",
        rarity: "Legendary Rare",
        level: 1,
        health: 2475,
        damage: 1425,
        range: 250,
        kb: 2,
        speed: 12,
        dps: 395,
        target: "Area",
        tba: "3.60",
        anim: "0.77",
        spawn: "6.20",
        cost: 825,
        ability:
          "u1Against angelu2: b1Resistantb2 (only takes 0.25x damage) b1Insane Damageb2 (inflicts 5.0x damage)",
        iscrazed: null,
        level2: this.state.compareCatsLevels,
      },
      {
        key: "526-1",
        name: "Kintaro",
        number: "526-1",
        form: "Normal",
        rarity: "Uber Super Rare",
        level: 1,
        health: 1350,
        damage: 675,
        range: 350,
        kb: 3,
        speed: 16,
        dps: 180,
        target: "Area",
        tba: "3.77",
        anim: "1.07",
        spawn: "8.20",
        cost: 840,
        ability:
          "u1Against angelu2: b1Slowb2 (30% chance to slow for 2.5s) \nu1General Abilitiesu2: b1Long Distanceb2 (Effective range 250~450) b1Multi-hit attackb2 (Attacks thrice consecutively) b1Savage Blowb2 (10% chance to inflict an attack with 2x damage to non-Metal enemies)",
        iscrazed: null,
        level2: this.state.compareCatsLevels,
      },
      {
        key: "135-1",
        name: "Urashima Taro",
        number: "135-1",
        form: "Normal",
        rarity: "Uber Super Rare",
        level: 1,
        health: 1925,
        damage: 800,
        range: 330,
        kb: 3,
        speed: 5,
        dps: 342,
        target: "Area",
        tba: "2.33",
        anim: "0.37",
        spawn: "8.87",
        cost: 1170,
        ability:
          "u1Against black, angelu2: b1Resistantb2 (only takes 0.25x damage)",
        iscrazed: null,
        level2: this.state.compareCatsLevels,
      },
      {
        key: "323-1",
        name: "Sarukani",
        number: "323-1",
        form: "Normal",
        rarity: "Uber Super Rare",
        level: 1,
        health: 1700,
        damage: 900,
        range: 300,
        kb: 4,
        speed: 12,
        dps: 325,
        target: "Area",
        tba: "2.77",
        anim: "0.60",
        spawn: "7.53",
        cost: 780,
        ability:
          "u1Against angel, zombieu2: b1Strongb2 (inflicts 1.5x damage, takes only 0.5x damage) \r\nu1General Abilitiesu2: b1Zombie Killerb2 (Stops zombies from reviving)",
        iscrazed: null,
        level2: this.state.compareCatsLevels,
      },
      {
        key: "137-1",
        name: "Momotaro",
        number: "137-1",
        form: "Normal",
        rarity: "Uber Super Rare",
        level: 1,
        health: 1800,
        damage: 765,
        range: 280,
        kb: 3,
        speed: 10,
        dps: 290,
        target: "Area",
        tba: "2.63",
        anim: "0.67",
        spawn: "4.87",
        cost: 900,
        ability:
          "u1Against red, angelu2: b1Freezeb2 (30% chance to freeze for 2.33s)",
        iscrazed: null,
        level2: this.state.compareCatsLevels,
      },
      {
        key: "139-1",
        name: "Princess Kaguya",
        number: "139-1",
        form: "Normal",
        rarity: "Uber Super Rare",
        level: 1,
        health: 1125,
        damage: 625,
        range: 280,
        kb: 3,
        speed: 8,
        dps: 418,
        target: "Area",
        tba: "1.50",
        anim: "0.20",
        spawn: "7.53",
        cost: 600,
        ability:
          "u1Against metal, angelu2: b1Slowb2 (20% chance to slow for 2.33s)",
        iscrazed: null,
        level2: this.state.compareCatsLevels,
      },
      {
        key: "136-1",
        name: "The Grateful Crane",
        number: "136-1",
        form: "Normal",
        rarity: "Uber Super Rare",
        level: 1,
        health: 1388,
        damage: 600,
        range: 200,
        kb: 3,
        speed: 4,
        dps: 750,
        target: "Area",
        tba: "0.80",
        anim: "0.17",
        spawn: "6.87",
        cost: 832,
        ability:
          "u1Against floating, angelu2: b1Knockbackb2 (20% chance of knockback)",
        iscrazed: null,
        level2: this.state.compareCatsLevels,
      },
      {
        key: "204-1",
        name: "Kachi-Kachi",
        number: "204-1",
        form: "Normal",
        rarity: "Uber Super Rare",
        level: 1,
        health: 1500,
        damage: 175,
        range: 290,
        kb: 4,
        speed: 16,
        dps: 278,
        target: "Area",
        tba: "0.63",
        anim: "0.10",
        spawn: "7.53",
        cost: 720,
        ability:
          "u1Against angel, alienu2: b1Weakenb2 (15% chance to weaken by 50% for 2.33s)",
        iscrazed: null,
        level2: this.state.compareCatsLevels,
      },
    ];

    const tierList = [
      {
        tier: "SS",
        cats: [],
      },
      {
        tier: "S",
        cats: [{ name: "Kasa Jizo", number: "138-1" }],
      },
      {
        tier: "A+",
        cats: [],
      },
      {
        tier: "A",
        cats: [{ name: "Kintaro", number: "526-1" }],
      },
      {
        tier: "B+",
        cats: [
          { name: "Ushiwakamaru", number: "452-1" },
          { name: "Urashima Taro", number: "135-1" },
          { name: "Sarukani", number: "323-1" },
          { name: "Momotaro", number: "137-1" },
        ],
      },
      {
        tier: "B",
        cats: [],
      },
      {
        tier: "B-",
        cats: [
          { name: "Princess Kaguya", number: "139-1" },
          { name: "The Grateful Crane", number: "136-1" },
        ],
      },
      {
        tier: "C+",
        cats: [{ name: "Kachi-Kachi", number: "204-1" }],
      },
      {
        tier: "C",
        cats: [],
      },
      {
        tier: "D",
        cats: [],
      },
    ];

    // console.log(typeof(bestCats))

    return (
      <div>
        <div className="pagetitle">
          <h1 style={{ padding: "10px 0 0 0", marginBottom: "6px" }}>
            Tier List
          </h1>
          <Divider style={{ margin: "0 0 0 0", padding: "0 0 0 0" }} />
        </div>
        <Layout style={{ padding: "0 12px 0 12px", background: "white" }}>
          <Content className="flexible-width">
            <Row style={{ padding: "16px 0 0 0" }}>
              <div>
                {this.state.viewportWidth > 1024 ? (
                  <VenatusAdWithPlaceholder
                    placementId={VENATUS_DESKTOP_LEADERBOARD}
                  />
                ) : (
                  ""
                  // <VenatusAdWithPlaceholder
                  //   placementId={VENATUS_MOBILE_LEADERBOARD}
                  // />
                )}
                <h2 style={{ marginTop: "12px", fontSize: "24px" }}>
                  Ultra Souls Tier List
                </h2>
                <p></p>
                <div>
                  Tier list for Ancient Hero Ultra Souls, listed from worst to
                  best. Credit goes to the Tier List on the{" "}
                  <a href="https://www.reddit.com/r/battlecats/wiki/index">
                    Reddit r/battlecats Wiki
                  </a>
                  &nbsp;under the Cat Guides.
                  <p></p>
                  <i>Last updated: 2 April 2021</i>
                </div>
              </div>
            </Row>

            <Row style={{ margin: "16px 0 0 0" }}>
              <FacebookShareButton
                url={"http://mygamatoto.com" + window.location.pathname}
                style={{ marginRight: "0.25rem" }}
              >
                <FacebookIcon size={32} round />
              </FacebookShareButton>
              <TwitterShareButton
                url={"http://mygamatoto.com" + window.location.pathname}
                title="MyGamatoto - Ultra Souls Tier List"
                style={{ marginRight: "0.25rem" }}
              >
                <TwitterIcon size={32} round />
              </TwitterShareButton>
              <RedditShareButton
                url={"http://mygamatoto.com" + window.location.pathname}
                style={{ marginRight: "0.25rem" }}
              >
                <RedditIcon size={32} round />
              </RedditShareButton>
              <VKShareButton
                url={"http://mygamatoto.com" + window.location.pathname}
                title="MyGamatoto - Ultra Souls Tier List"
                style={{ marginRight: "0.25rem" }}
              >
                <VKIcon size={32} round />
              </VKShareButton>
            </Row>
            {this.state.viewportWidth > 1024 ? (
              ""
            ) : (
              <div style={{ margin: "10px 0 0 0" }}>
                <div
                  class="vm-placement"
                  id="vm-av"
                  data-format="isvideo"
                ></div>
              </div>
            )}
            <Row style={{ padding: "16px 0 0px 0" }}>
              <Row style={{ padding: "16px 0 16px 0" }}>
                <Divider orientation="left" style={{ fontSize: "24px" }}>
                  9.
                </Divider>
                <div
                  style={{
                    backgroundColor: "#ffa50038",
                    padding: "16px 8px",
                    margin: "20px 0",
                  }}
                >
                  <img
                    src={
                      "https://onestoppress.com/images/" +
                      bestCats[8].number +
                      ".png"
                    }
                    alt={bestCats[8].name}
                    style={{ float: "left", paddingRight: "8px" }}
                  />
                  <div style={{ padding: "3.5px 0px 0.5px 0px" }}>
                    <h4>
                      &nbsp;
                      <Link
                        to={
                          "/catinfo/" +
                          bestCats[8].number.slice(0, 3) +
                          "/" +
                          bestCats[8].name
                        }
                      >
                        {bestCats[8].name}
                      </Link>
                    </h4>
                  </div>
                </div>
                <p></p>
                <div>
                  <b>Description: </b>
                  Cat Army R&amp;D cloned an ancient superweapon: a cute Tanuki
                  that can survive being set on fire… Might weaken Alien/Angel
                  attacks. (Area Attack)
                  <p></p>
                  <b>Other forms: </b>Fire Squad Kachiyama, Kachiyama Assault
                  Brigade
                  <p></p>
                  <b>Pros: </b>Fast attack speed with area attacks that make him
                  a acceptable generalist in his normal form. True form adds
                  range and better abilities that make him truly shine against
                  angel and alien enemies, being able to keep them weak for
                  nearly all the time.
                  <p></p>
                  <b>Cons: </b>Compared to his normal form,{" "}
                  <Link to={"/catinfo/199/Thaumaturge%20Cat"}>
                    Thaumaturge Cat
                  </Link>{" "}
                  is better at weakening enemies in all the ways that matter
                  except for its single-target attack. In true form, it's one of
                  the better cats at weakening enemies, but there are also other
                  ways to control a crowd like Freezing or Slowing.
                </div>
              </Row>
              <BestCatsTable
                selectedCats={bestCats.filter(
                  (item) => item.name === "Kachi-Kachi"
                )}
                viewportHeight={this.state.viewportHeight}
              />
            </Row>

            <div style={{ paddingTop: "1em" }} />
            {this.state.viewportWidth > 1024 ? (
              <VenatusAdWithPlaceholder
                placementId={VENATUS_DESKTOP_LEADERBOARD}
              />
            ) : (
              <VenatusAdWithPlaceholder
                placementId={VENATUS_MOBILE_LEADERBOARD}
              />
            )}
            <Row style={{ padding: "16px 0 0px 0" }}>
              <Row style={{ padding: "16px 0 16px 0" }}>
                <Divider orientation="left" style={{ fontSize: "24px" }}>
                  8.
                </Divider>
                <div
                  style={{
                    backgroundColor: "#ffa50038",
                    padding: "16px 8px",
                    margin: "20px 0",
                  }}
                >
                  <img
                    src={
                      "https://onestoppress.com/images/" +
                      bestCats[7].number +
                      ".png"
                    }
                    alt={bestCats[7].name}
                    style={{ float: "left", paddingRight: "8px" }}
                  />
                  <div style={{ padding: "3.5px 0px 0.5px 0px" }}>
                    <h4>
                      &nbsp;
                      <Link
                        to={
                          "/catinfo/" +
                          bestCats[7].number.slice(0, 3) +
                          "/" +
                          bestCats[7].name
                        }
                      >
                        {bestCats[7].name}
                      </Link>
                    </h4>
                  </div>
                </div>
                <p></p>
                <div>
                  <b>Description: </b>
                  Champion of this year's Bird-Cat contest held at the lake
                  every year. (Area Attack) Might knockback Floating/Angel
                  enemies.
                  <p></p>
                  <b>Other forms: </b>Super Galaxy Cosmo, Ultima Galaxy Cosmo
                  <p></p>
                  <b>Pros: </b>Also on the{" "}
                  <Link to={"/best-cats-for-speed"}>Best Cats for Speed</Link>{" "}
                  and{" "}
                  <Link to={"/best-cats-for-range"}>Best Cats for Range</Link>{" "}
                  list. A situational uber that does exceptionally well against
                  long-ranged enemies such as Rain D or THE SLOTH. In true form,
                  he's a great help in stages like Floor 32 of Heavenly Tower
                  with long-ranged bosses and enemies that keep pushing.
                  <p></p>
                  <b>Cons: </b>Normal form is nothing to shout about. True form
                  also has a rather long time between attacks. Avoid using the
                  Cat Cannon with him, as he has a tendency to rush towards the
                  frontline.
                </div>
              </Row>
              <BestCatsTable
                selectedCats={bestCats.filter(
                  (item) => item.name === "The Grateful Crane"
                )}
                viewportHeight={this.state.viewportHeight}
              />
            </Row>

            <Row style={{ padding: "16px 0 0px 0" }}>
              <Row style={{ padding: "16px 0 16px 0" }}>
                <Divider orientation="left" style={{ fontSize: "24px" }}>
                  7.
                </Divider>
                <div
                  style={{
                    backgroundColor: "#ffa50038",
                    padding: "16px 8px",
                    margin: "20px 0",
                  }}
                >
                  <img
                    src={
                      "https://onestoppress.com/images/" +
                      bestCats[6].number +
                      ".png"
                    }
                    alt={bestCats[6].name}
                    style={{ float: "left", paddingRight: "8px" }}
                  />
                  <div style={{ padding: "3.5px 0px 0.5px 0px" }}>
                    <h4>
                      &nbsp;
                      <Link
                        to={
                          "/catinfo/" +
                          bestCats[6].number.slice(0, 3) +
                          "/" +
                          bestCats[6].name
                        }
                      >
                        {bestCats[6].name}
                      </Link>
                    </h4>
                  </div>
                </div>
                <p></p>
                <div>
                  <b>Description: </b>
                  Beautiful Cat on assignment from the Moon. Her true nature is
                  still top secret… Might slow Angel/Metal enemies. (Area Atk)
                  <p></p>
                  <b>Other forms: </b>The Death Moon, The Chaos Moon
                  <p></p>
                  <b>Pros: </b>Low time between attacks and decent spawn rate
                  makes it an effective crowd controller against metal/angel
                  stages. Its area attack is the real trump card against metal
                  enemies, making it a better choice than many anti-metal crowd
                  controllers such as{" "}
                  <Link to={"/catinfo/127/Clockwork%20Cat"}>Clockwork Cat</Link>
                  . True form grants 100% chance chance of slowing and vastly
                  improves health and damage, letting it deliver solid damage
                  and control the crowd from the back.
                  <p></p>
                  <b>Cons: </b>If only if its chance to slow could be higher
                  than 20% in its normal form, or its time between attacks
                  shorter in true form.
                </div>
              </Row>
              <BestCatsTable
                selectedCats={bestCats.filter(
                  (item) => item.name === "Princess Kaguya"
                )}
                viewportHeight={this.state.viewportHeight}
              />
            </Row>

            <Row style={{ padding: "16px 0 0 0" }}>
              <Row style={{ padding: "16px 0 16px 0" }}>
                <Divider orientation="left" style={{ fontSize: "24px" }}>
                  6.
                </Divider>
                <div
                  style={{
                    backgroundColor: "#ffa50038",
                    padding: "16px 8px",
                    margin: "20px 0",
                  }}
                >
                  <img
                    src={
                      "https://onestoppress.com/images/" +
                      bestCats[5].number +
                      ".png"
                    }
                    alt={bestCats[5].name}
                    style={{ float: "left", paddingRight: "8px" }}
                  />
                  <div style={{ padding: "3.5px 0px 0.5px 0px" }}>
                    <h4>
                      &nbsp;
                      <Link
                        to={
                          "/catinfo/" +
                          bestCats[5].number.slice(0, 3) +
                          "/" +
                          bestCats[5].name
                        }
                      >
                        {bestCats[5].name}
                      </Link>
                    </h4>
                  </div>
                </div>
                <p></p>
                <div>
                  <b>Description: </b>On a quest to find anyone stronger than
                  him. Aim for the top! Watch the fans… Might freeze Angel/Red
                  enemies. (Area attack)
                  <p></p>
                  <b>Other forms: </b>The Peach Angels, The Peach Devils
                  <p></p>
                  <b>Pros: </b>In its normal form, it controls crowds in the
                  same way as{" "}
                  <Link to={"/catinfo/151/Juliet%20Cat"}>Juliet Cat</Link>, just
                  more stackable with half the respawn time, slightly higher
                  range, and unfortunately half the health and damage too. Its
                  true form gives a huge boost to its range, which helps it
                  control enemies like Angelic Sleipnir, and its fast speed
                  gives it an edge in time-based stages.
                  <p></p>
                  <b>Cons: </b>Relatively low damage and low freeze probability.
                  In true form, cats like{" "}
                  <Link to={"/catinfo/440/Empress%20Chronos"}>
                    Empress Chronos
                  </Link>{" "}
                  and <Link to={"/catinfo/043/Ice%20Cat"}>Ice Cat</Link> do
                  better at controlling enemies.{" "}
                </div>
              </Row>
              <BestCatsTable
                selectedCats={bestCats.filter(
                  (item) => item.name === "Momotaro"
                )}
                viewportHeight={this.state.viewportHeight}
              />
            </Row>

            <Row style={{ padding: "16px 0 0px 0" }}>
              <Row style={{ padding: "16px 0 16px 0" }}>
                <Divider orientation="left" style={{ fontSize: "24px" }}>
                  5.
                </Divider>
                <div
                  style={{
                    backgroundColor: "#ffa50038",
                    padding: "16px 8px",
                    margin: "20px 0",
                  }}
                >
                  <img
                    src={
                      "https://onestoppress.com/images/" +
                      bestCats[4].number +
                      ".png"
                    }
                    alt={bestCats[4].name}
                    style={{ float: "left", paddingRight: "8px" }}
                  />
                  <div style={{ padding: "3.5px 0px 0.5px 0px" }}>
                    <h4>
                      &nbsp;
                      <Link
                        to={
                          "/catinfo/" +
                          bestCats[4].number.slice(0, 3) +
                          "/" +
                          bestCats[4].name
                        }
                      >
                        {bestCats[4].name}
                      </Link>
                    </h4>
                  </div>
                </div>
                <p></p>
                <div>
                  <b>Description: </b>
                  Won best supporting actor as a li'l monkey for Selfish
                  Persimmons. Everyone hates working with him. Strong area atk
                  vs Angels/Zombies.
                  <p></p>
                  <b>Other forms: </b>Rock Revengers, The One-Hit Wonders
                  <p></p>
                  <b>Pros: </b>Good anti-zombie damage dealer that comes with a
                  reasonable price tag for those cash-strapped zombie stages as
                  well as a short time between attacks. Does well next to zombie
                  crowd controllers, such as{" "}
                  <Link to={"/catinfo/326/Welterweight%20Cat"}>
                    Welterweight Cat
                  </Link>
                  . True form can also survive multiple hits from Daboo of the
                  Dead.
                  <p></p>
                  <b>Cons: </b>His anti-angel trait doesn't add much value, as
                  there are usually better cats against angels. His cost and
                  quick respawn can easily drain your wallet on zombie stages
                  where cash becomes tight, so be careful to deploy him in
                  moderation.
                </div>
              </Row>
              <BestCatsTable
                selectedCats={bestCats.filter(
                  (item) => item.name === "Sarukani"
                )}
                viewportHeight={this.state.viewportHeight}
              />
            </Row>

            <Row style={{ padding: "16px 0 0px 0" }}>
              <Row style={{ padding: "16px 0 16px 0" }}>
                <Divider orientation="left" style={{ fontSize: "24px" }}>
                  4.
                </Divider>
                <div
                  style={{
                    backgroundColor: "#ffa50038",
                    padding: "16px 8px",
                    margin: "20px 0",
                  }}
                >
                  <img
                    src={
                      "https://onestoppress.com/images/" +
                      bestCats[3].number +
                      ".png"
                    }
                    alt={bestCats[3].name}
                    style={{ float: "left", paddingRight: "8px" }}
                  />
                  <div style={{ padding: "3.5px 0px 0.5px 0px" }}>
                    <h4>
                      &nbsp;
                      <Link
                        to={
                          "/catinfo/" +
                          bestCats[3].number.slice(0, 3) +
                          "/" +
                          bestCats[3].name
                        }
                      >
                        {bestCats[3].name}
                      </Link>
                    </h4>
                  </div>
                </div>
                <p></p>
                <div>
                  <b>Description: </b>
                  Elite Cat agent that holds the secret of the government
                  bioweapon T.U.R.T.L.E. (Area Atk) Resistant to Black/Angel
                  attacks.
                  <p></p>
                  <b>Other forms: </b>Guardian Gamereon, King Gamereon
                  <p></p>
                  <b>Pros: </b>Identical range and damage to{" "}
                  <Link to={"/catinfo/042/Cyborg%20Cat"}>Cyborg Cat</Link>, just
                  with nearly 4x the respawn rate, slightly higher cost and half
                  the time between attacks. It'll be a good choice for most
                  angel/black stages.
                  <p></p>
                  <b>Cons: </b>Don't let its Resistant ability mislead you into
                  using it as a meatshield. Its mid range helps increase its own
                  survivability rather than protect units behind it.
                </div>
              </Row>
              <BestCatsTable
                selectedCats={bestCats.filter(
                  (item) => item.name === "Urashima Taro"
                )}
                viewportHeight={this.state.viewportHeight}
              />
            </Row>

            <Row style={{ padding: "16px 0 0 0" }}>
              <Row style={{ padding: "16px 0 16px 0" }}>
                <Divider orientation="left" style={{ fontSize: "24px" }}>
                  3.
                </Divider>
                <div
                  style={{
                    backgroundColor: "#ffa50038",
                    padding: "16px 8px",
                    margin: "20px 0",
                  }}
                >
                  <img
                    src={
                      "https://onestoppress.com/images/" +
                      bestCats[2].number +
                      ".png"
                    }
                    alt={bestCats[2].name}
                    style={{ float: "left", paddingRight: "8px" }}
                  />
                  <div style={{ padding: "3.5px 0px 0.5px 0px" }}>
                    <h4>
                      &nbsp;
                      <Link
                        to={
                          "/catinfo/" +
                          bestCats[2].number.slice(0, 3) +
                          "/" +
                          bestCats[2].name
                        }
                      >
                        {bestCats[2].name}
                      </Link>
                    </h4>
                  </div>
                </div>
                <p></p>
                <div>
                  <b>Description: </b>Young exec at AxeCorp, managing operations
                  at the mountain office with intern Li'l Bear. Might Slow
                  Angels and strike a Savage Blow.
                  <p></p>
                  <b>Other forms: </b>Kinrangers RoboForce, Kinrangers GigaForce
                  <p></p>
                  <b>Pros: </b>Well-balanced crowd controller against angels,
                  with range being its main selling point. Compared to cats like{" "}
                  <Link to={"/catinfo/151/Juliet%20Cat"}>Juliet Cat</Link> and{" "}
                  <Link to={"/catinfo/137/Momotaro"}>Momotaro</Link>, its
                  distance from the frontline means it'll be able to survive
                  longer to control the angel enemies, making it very
                  value-for-money in typically cash-strapped angel stages.
                  <p></p>
                  <b>Cons: </b>Funnily enough, its high speed in its evolved
                  form causes it to rush too quickly towards its enemies,
                  negating its range advantage.
                </div>
              </Row>
              <BestCatsTable
                selectedCats={bestCats.filter(
                  (item) => item.name === "Kintaro"
                )}
                viewportHeight={this.state.viewportHeight}
              />
            </Row>

            <Row style={{ padding: "16px 0 0px 0" }}>
              <Row style={{ padding: "16px 0 16px 0" }}>
                <Divider orientation="left" style={{ fontSize: "24px" }}>
                  2.
                </Divider>
                <div
                  style={{
                    backgroundColor: "#ffa50038",
                    padding: "16px 8px",
                    margin: "20px 0",
                  }}
                >
                  <img
                    src={
                      "https://onestoppress.com/images/" +
                      bestCats[1].number +
                      ".png"
                    }
                    alt={bestCats[1].name}
                    style={{ float: "left", paddingRight: "8px" }}
                  />
                  <div style={{ padding: "3.5px 0px 0.5px 0px" }}>
                    <h4>
                      &nbsp;
                      <Link
                        to={
                          "/catinfo/" +
                          bestCats[1].number.slice(0, 3) +
                          "/" +
                          bestCats[1].name
                        }
                      >
                        {bestCats[1].name}
                      </Link>
                    </h4>
                  </div>
                </div>
                <p></p>
                <div>
                  <b>Description: </b>A celestial hero who has vowed to avenge
                  his father. His magic flute can track the evil H.E.I.K.E.
                  corps. Tough vs Angels with Insane Area Damage.
                  <p></p>
                  <b>Other forms: </b>Colossal Benkei
                  <p></p>
                  <b>Pros: </b>This Legendary is the ultimate anti-angel damage
                  dealer. Think of him as a{" "}
                  <Link to={"/catinfo/152/Pizza%20Cat"}>Pizza Cat</Link> for
                  angels when in normal form, but way more spammable as he's
                  cheaper and respawns in a third of the time. In its evolved
                  form, its long range and insane damage makes it a perfect
                  anti-angel nuke as long as it's properly protected. It's a
                  slightly better generalist than{" "}
                  <Link to={"/catinfo/413/Eva%20Unit-00"}>Eva Unit-00</Link> (if
                  you ignore the Wave Shield and anti-floating traits) so that
                  just shows how good he is.
                  <p></p>
                  <b>Cons: </b>Base stats are nothing spectacular, so he won't
                  see much employment as a generalist. But let's be honest, you
                  can't make a cat too broken.
                </div>
              </Row>
              <BestCatsTable
                selectedCats={bestCats.filter(
                  (item) => item.name === "Ushiwakamaru"
                )}
                viewportHeight={this.state.viewportHeight}
              />
            </Row>

            <Row style={{ padding: "0px 0 0px 0" }}>
              <Row style={{ padding: "0px 0 16px 0" }}>
                <Divider orientation="left" style={{ fontSize: "24px" }}>
                  1.
                </Divider>
                <div
                  style={{
                    backgroundColor: "#ffa50038",
                    padding: "16px 8px",
                    margin: "20px 0",
                  }}
                >
                  <img
                    src={
                      "https://onestoppress.com/images/" +
                      bestCats[0].number +
                      ".png"
                    }
                    alt={bestCats[0].name}
                    style={{ float: "left", paddingRight: "8px" }}
                  />
                  <div style={{ padding: "3.5px 0px 0.5px 0px" }}>
                    <h4>
                      &nbsp;
                      <Link
                        to={
                          "/catinfo/" +
                          bestCats[0].number.slice(0, 3) +
                          "/" +
                          bestCats[0].name
                        }
                      >
                        {bestCats[0].name}
                      </Link>
                    </h4>
                  </div>
                </div>
                <p></p>
                <div>
                  <b>Description: </b>
                  It's said there's a shadowy organization who grants wishes
                  made to these statues. (Area Atk) Deals massive damage to
                  Black/Angel types.
                  <p></p>
                  <b>Other forms: </b>Jizo's Moving Castle, Jizo's Mega-Castle
                  <p></p>
                  <b>Pros: </b>By far the best spammable anti-black damage
                  dealer in the game. The closest comparisons are{" "}
                  <Link to={"/catinfo/152/Pizza%20Cat"}>Pizza Cat</Link>,{" "}
                  <Link to={"/catinfo/042/Paris%20Cat"}>Paris Cat</Link>, and{" "}
                  <Link to={"/catinfo/153/Slapstick%20Cats"}>
                    Slapstick Cats
                  </Link>{" "}
                  — he has higher range than the first, lower cost and better
                  general damage than the second, and nearly half the respawn
                  time of the third. He's the MVP in black enemy stages, as he
                  protects your frontline against those black enemies which tend
                  to be pushers. His evolved form sees less use, and is
                  essentially a{" "}
                  <Link to={"/catinfo/026/Crazed%20Bahamut%20Cat"}>
                    Crazed Bahamut Cat
                  </Link>{" "}
                  but with more than 4 times its health, shorter time between
                  attacks, massive damage against angels and blacks, and is
                  $1425 more costly.
                  <p></p>
                  <b>Cons: </b>Relatively weak health and range, so tends to die
                  easily against pushers. This is usually not a problem when
                  paired with complementary cats like{" "}
                  <Link to={"/catinfo/128/Bombercat"}>Bombercat</Link> or{" "}
                  <Link to={"/catinfo/149/Ramen%20Cat"}>Ramen Cat</Link>.
                </div>
              </Row>
              <BestCatsTable
                selectedCats={bestCats.filter(
                  (item) => item.name === "Kasa Jizo"
                )}
                viewportHeight={this.state.viewportHeight}
              />
            </Row>

            <Row style={{ padding: "6px 0 6px 0", marginTop: "6px" }}>
              <Divider orientation="left" style={{ fontSize: "24px" }}>
                Tier List
              </Divider>
              <TierListTable
                selectedCats={tierList}
                viewportHeight={this.state.viewportHeight}
              />
            </Row>

            <Row style={{ padding: "6px 0 6px 0" }}>
              <Divider />
              <h3>Compare all 9 cats below</h3>
              <BestCatsTable
                selectedCats={bestCats}
                viewportHeight={this.state.viewportHeight}
              />
            </Row>

            <Row
              style={{
                padding: "24px 20px 18px 20px",
                backgroundColor: "#ffa50038",
                textAlign: "center",
                margin: "0 0 8px 0",
              }}
            >
              <div style={{ fontSize: "16px" }}>
                Want to compare the stats of any cat in The Battle Cats?
              </div>
              <Divider
                style={{ backgroundColor: "orange", marginTop: "12px" }}
              ></Divider>
              <Button href="/comparecats" size="large">
                Compare more cats
              </Button>
            </Row>
          </Content>
        </Layout>
        {/* <HorizontalAdPopup
          dataAdClient="ca-pub-1920730948516638"
          dataAdSlot="3694383950"
        ></HorizontalAdPopup> */}
        {/* <div id="waldo-tag-14678"></div> */}
        {this.state.viewportWidth > 1024 ? (
          <div>
            <VenatusAd
              placementId={VENATUS_RICH_MEDIA_WITH_STICKY_VERTICAL}
              style={{ display: "none" }}
            />
          </div>
        ) : (
          <div>
            <VenatusAd
              placementId={VENATUS_RICH_MEDIA}
              style={{ display: "none" }}
            />
          </div>
        )}
      </div>
    );
  }
}

export default UltraSouls;

UltraSouls.propTypes = {
  applyViewportChange: PropTypes.number,
};

UltraSouls.defaultProps = {
  applyViewportChange: 250,
};



// WEBPACK FOOTER //
// ./src/components/content/tierlist/UltraSouls.js